/** Case filters and the open inspector must survive every router navigation. */
export function investigationSearch(search: Record<string, unknown>): {
  relationship?: string; funds?: string; fundsSteps?: string; steps?: string; inspect?: string;
} {
  const text = (value: unknown) => typeof value === "string" ? value : undefined;
  return {
    relationship: text(search.relationship),
    funds: text(search.funds),
    fundsSteps: text(search.fundsSteps),
    steps: text(search.steps),
    // Omitting this closes the panel immediately after a subject click: its
    // URL binding interprets the stripped parameter as Back/dismiss.
    inspect: text(search.inspect),
  };
}
